import { Box, VStack } from "@chakra-ui/react"
import PackageProvider, { usePackageContext } from "./PackageProvider"
import { PackageDetails } from "./PackageUI"
import {
  PackageButton,
  PackageColorMode,
  PackageDataSource,
  PackageThemeOverrides
} from "./types"

const PackageCard = () => {
  const { theme } = usePackageContext()

  return (
    <Box
      w="100%"
      maxW={{ base: "100%", md: "400px" }}
      mx="auto"
      borderRadius="card"
      boxShadow="card"
      backgroundColor={theme.backgroundColor}
      overflow="hidden"
    >
      <VStack align="stretch" py={4} p={0}>
        <PackageDetails />
      </VStack>
    </Box>
  )
}

type PackageCardProps = {
  dataSource?: PackageDataSource
  themeOverrides?: PackageThemeOverrides
  actionButton?: PackageButton
  colorMode?: PackageColorMode
}

const PackageCardContainer = ({
  dataSource,
  themeOverrides,
  actionButton,
  colorMode
}: PackageCardProps) => {
  return (
    <PackageProvider
      variant="card"
      actionButton={actionButton}
      dataSource={dataSource}
      themeOverrides={themeOverrides}
      colorMode={colorMode}
    >
      <PackageCard />
    </PackageProvider>
  )
}

export default PackageCardContainer
